var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import { ImageTextSlide } from '../slides/ImageTextSlide';
import SwiperCore, { Keyboard, Mousewheel } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './ScrollLockedImageText.scss';
import { useNavigate, useLocation } from 'react-router-dom';
import imageText1a from '../../assets/images/scrollLockedImageText/slide1-a.webp';
import imageText2a from '../../assets/images/scrollLockedImageText/InvestmentSolution.webp';
import imageText2b from '../../assets/images/scrollLockedImageText/slide2-b.webp';
import imageText3a from '../../assets/images/scrollLockedImageText/slide3-a.webp';
import imageText4a from '../../assets/images/scrollLockedImageText/slide4-a.webp';
import imageText5a from '../../assets/images/scrollLockedImageText/slide5-a.webp';
import imageText6a from '../../assets/images/scrollLockedImageText/groupImage.webp';
import imageText6b from '../../assets/images/scrollLockedImageText/slide6-b.webp';
import imageText7a from '../../assets/images/scrollLockedImageText/slide7-a.webp';
import imageText7b from '../../assets/images/scrollLockedImageText/slide7-b.webp';
import leftArrow from '../../assets/images/scrollLockedImageText/leftArrow.svg';
import leftArrowDisabled from '../../assets/images/scrollLockedImageText/leftArrowDisabled.svg';
import rightArrow from '../../assets/images/scrollLockedImageText/rightArrow.svg';
import rightArrowDisabled from '../../assets/images/scrollLockedImageText/rightArrowDisabled.svg';
import useViewport from '../../hooks/useViewport';
import { useOnScreen } from '../../hooks/useOnScreen';
import { ProgressIndicator } from '../ProgressIndicator/ProgressIdicator';
SwiperCore.use([Keyboard, Mousewheel]);
export var data = [
    {
        slide: 1,
        eyebrowText: 'Our Ecosystem',
        headLineText: 'Wealth Management Technology',
        body: 'Envestnet’s software helps to streamline and automate the wealth management process so you spend less time on administrative tasks and more time on clients.',
        bulletList: [
            'Trading and reporting',
            'Client portal',
            'Client management (CRM)',
            'Portfolio management',
            'Tax management',
            'Advisor services',
        ],
        backgroudColor: '#005f9e',
        accoladesBanner: {
            secondaryImgSrc: '',
            SubHead: null,
            body: null,
        },
        mainImgSrc: imageText1a,
        mainImgAlt: 'Wealth Management Technology',
        links: [
            {
                ctaCopy: 'Technology for RIAs',
                ctaLink: 'http://example.com',
            },
            {
                ctaCopy: 'Technology for Financial Professionals',
                ctaLink: 'http://example.com',
            },
        ],
        id: 'wealth-management-technology',
    },
    {
        slide: 2,
        eyebrowText: 'Our Ecosystem',
        headLineText: 'Investment Solutions',
        body: 'From comprehensive manager research to portfolio consulting and management, Envestnet’s investment solutions and services help you create personalized portfolios that align to your clients’ goals.',
        bulletList: [
            'Managed accounts',
            'Tax overlay',
            'Direct indexing',
            'Sustainable investing',
        ],
        backgroudColor: '#8bd3e6',
        accoladesBanner: {
            secondaryImgSrc: imageText2b,
            secondaryImgAlt: '2021 SUSTANAIBLE & ESG INVESTING WINNER',
            SubHead: '2021 SUSTANAIBLE & ESG INVESTING WINNER',
            body: 'Envestnet | PMC named the 2021 winner in MMI/Barron’s Industry Awards.',
        },
        mainImgSrc: imageText2a,
        mainImgAlt: 'Investment Solutions',
        links: [
            {
                ctaCopy: 'Learn More About Envestnet | PMC',
                ctaLink: 'http://example.com',
            },
            {
                ctaCopy: 'Learn More About Impact Investing',
                ctaLink: 'http://example.com',
            },
        ],
        id: 'investment-solutions',
    },
    {
        slide: 3,
        eyebrowText: 'Our Ecosystem',
        headLineText: 'Financial Planning',
        body: 'Empower clients of all ages and financial situations to make their dreams a reality by setting realistic expectations and discovering powerful answers to complex questions through ongoing collaboration.',
        bulletList: [
            'Goals-based planning',
            'Cash flow-based planning',
            'Tax strategies',
            'Advanced to estate and legacy',
            'Client-initiated planning',
            'SuperSolve',
            'Smart defaults',
        ],
        backgroudColor: '#fdb515',
        accoladesBanner: {
            secondaryImgSrc: '',
            SubHead: null,
            body: null,
        },
        mainImgSrc: imageText3a,
        mainImgAlt: 'Financial Planning',
        links: [
            {
                ctaCopy: 'Learn More',
                ctaLink: 'http://example.com',
            },
        ],
        id: 'financial-planning',
    },
    {
        slide: 4,
        eyebrowText: 'Our Ecosystem',
        headLineText: 'Data Intelligence',
        body: 'As the market leader in financial data aggregation, Envestnet enables the generation of meaningful digital insights and interactions while powering intelligent financial plans.',
        bulletList: [
            'Aggregation',
            'Transaction data',
            'Account verification',
            'Client onboarding',
            'Open banking',
            'FastLink',
        ],
        backgroudColor: '#f46b10',
        accoladesBanner: {
            secondaryImgSrc: '',
            SubHead: null,
            body: null,
        },
        mainImgSrc: imageText4a,
        class: 'slideNewSize',
        mainImgAlt: 'Data Intelligence',
        links: [
            {
                ctaCopy: 'Learn More',
                ctaLink: 'http://example.com',
            },
        ],
        id: 'data-intelligence',
    },
    {
        slide: 5,
        eyebrowText: 'Our Ecosystem',
        headLineText: 'Analytics & Insights',
        body: 'By transforming data into actionable insights, Envestnet’s advanced analytics tools uncover practice and portfolio trends for a competitive business advantage.',
        bulletList: [
            'Insights Engine',
            'Income and spending trends',
            'Custom Dashboards',
            'Market research',
        ],
        backgroudColor: '#0074bd',
        accoladesBanner: {
            secondaryImgSrc: '',
            SubHead: null,
            body: null,
        },
        mainImgSrc: imageText5a,
        mainImgAlt: 'Analytics & Insights',
        links: [
            {
                ctaCopy: 'For Advisors',
                ctaLink: 'http://example.com',
            },
            {
                ctaCopy: 'For Market Researchers and Investment Managers',
                ctaLink: 'http://example.com',
            },
        ],
        id: 'analytics-and-insights',
    },
    {
        slide: 6,
        eyebrowText: 'Our Ecosystem',
        headLineText: 'Embedded Experiences',
        body: 'Envestnet’s financial wellness experiences facilitate more meaningful client engagement, allowing you to give personalized advice, offer financial coaching, or guide clients to the next best action in their digital experience.',
        bulletList: [
            'Wellness apps',
            'Conversational AI',
            'Virtual financial assistant',
            'Microsavings',
            'Embedded finance',
        ],
        backgroudColor: '#343741',
        accoladesBanner: {
            secondaryImgSrc: imageText6b,
            secondaryImgAlt: '2021 INDUSTRY DISRUPTOR',
            SubHead: '2021 INDUSTRY DISRUPTOR',
            body: 'Envestnet’s financial wellness ecosystem recognized as 2021’s industry disruptor by WealthManagment.com.',
        },
        mainImgSrc: imageText6a,
        mainImgAlt: 'Embedded Experiences',
        links: [
            {
                ctaCopy: 'For Learn More',
                ctaLink: 'http://example.com',
            },
        ],
        id: 'embedded-experiences',
    },
    {
        slide: 7,
        eyebrowText: 'Our Ecosystem',
        headLineText: 'Wealth Solutions',
        body: 'Envestnet’s exchange partners allow you to deliver greater personalization to client portfolios by easily integrating protection, coverage, and solutions alongside their investments.',
        bulletList: ['Insurance', 'Credit', 'Healthcare', 'Trust', 'Annuity'],
        backgroudColor: '#00818f',
        accoladesBanner: {
            secondaryImgSrc: imageText7b,
            secondaryImgAlt: '2020 Best Financial Product Comparison Service',
            SubHead: '2020 Best Financial Product Comparison Service',
            body: 'Envestnet’s insurance exchange named the 2020 winner by FinTech Breakthrough Awards.',
        },
        mainImgSrc: imageText7a,
        mainImgAlt: 'Wealth Solutions',
        links: [
            {
                ctaCopy: 'For Learn More',
                ctaLink: 'http://example.com',
            },
        ],
        id: 'wealth-solutions',
    },
];
var defaultProps = { data: data };
export var ScrollLockedImageText = function (_a) {
    var className = _a.className, data = _a.data;
    var scrollLockedImageTextRef = useRef(null);
    var isOnScreenScrollLockedImageText = useOnScreen(scrollLockedImageTextRef, 0.9);
    var visualViewport = useViewport().visualViewport;
    var dummyScrollTopRef = useRef(null);
    var _b = useState(null), swiper = _b[0], setSwiper = _b[1];
    var _c = useState(0), activeSlide = _c[0], setActiveSlide = _c[1];
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    // Handy Conditionals
    var isMobile = visualViewport.width < 1440;
    var slideChangeHandler = function (swiper) {
        var _a;
        setActiveSlide(swiper.activeIndex);
        var currentSlideId = (_a = swiper === null || swiper === void 0 ? void 0 : swiper.slides[swiper.activeIndex]) === null || _a === void 0 ? void 0 : _a.id;
        if (currentSlideId) {
            navigate(pathname + "#" + currentSlideId, { replace: true });
        }
    };
    var initSwiper = function (swiper) {
        setSwiper(swiper);
        var urlIds = window.location.href.split('#');
        var id = urlIds ? urlIds[urlIds.length - 1] : null;
        if (swiper && id !== null) {
            var target = swiper.slides;
            for (var i = 0; i < target.length; i++) {
                var ele = target[i];
                if (ele.id == id) {
                    swiper.slideTo(i);
                    break;
                }
            }
        }
    };
    var onLeftArrow = function () {
        swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
    };
    var onRightArrow = function () {
        swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
    };
    return (_jsxs("div", __assign({ className: "snap-center snap-x snap-mandatory flex justify-center relative flex-col scroll-lock-image_row_flow " + (className || ''), ref: scrollLockedImageTextRef }, { children: [!isMobile && (_jsxs(Swiper, __assign({ modules: [Keyboard, Mousewheel], keyboard: {
                    enabled: true,
                    pageUpDown: true,
                    onlyInViewport: false,
                }, mousewheel: false, onSwiper: initSwiper, slidesPerView: "auto", centeredSlides: true, onSlideChange: slideChangeHandler, effect: "fade", speed: 300 }, { children: [_jsx("div", { className: "h-[1px] absolute top-0", slot: "container-start", id: "container-start", ref: dummyScrollTopRef }, void 0),
                    data.map(function (slide) { return (_jsx(SwiperSlide, __assign({ style: { bottom: isMobile ? '0px' : '70px' }, id: slide.id }, { children: _jsx(ImageTextSlide, { className: "max-h-[calc(100vh - 41px)] md:max-h-[calc(100vh - 49px)] lg:max-h-[calc(100vh - 70px)] overflow-y-auto", data: slide }, void 0) }), "slide-" + slide.slide)); })] }), void 0)),
            isMobile &&
                data.map(function (slide, i) { return (_jsx(ImageTextSlide, { className: "max-h-[calc(100vh - 41px)] md:max-h-[calc(100vh - 49px)] lg:max-h-[calc(100vh - 70px)] overflow-y-auto", data: slide }, i)); }),
            !isMobile && (_jsxs("div", __assign({ className: "carousel-indicators absolute flex" }, { children: [_jsx("button", __assign({ className: "bottom-0 z-10 w-full relative", onClick: onLeftArrow, disabled: activeSlide === 0 }, { children: _jsx("img", { src: activeSlide === 0 ? leftArrowDisabled : leftArrow, style: { float: 'right' } }, void 0) }), void 0),
                    _jsx(ProgressIndicator, { className: "progress-indicator flex box-border justify-center items-center bottom-0 w-full relative  z-10", data: {
                            isOnScreen: isOnScreenScrollLockedImageText,
                            array: data,
                            onClick: function (i) {
                                swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(i);
                            },
                            activeSlide: activeSlide,
                            showArrow: false,
                        } }, void 0),
                    _jsx("button", __assign({ className: "bottom-0 z-10 w-full relative", onClick: onRightArrow, disabled: activeSlide === data.length - 1 }, { children: _jsx("img", { src: activeSlide === data.length - 1
                                ? rightArrowDisabled
                                : rightArrow }, void 0) }), void 0)] }), void 0))] }), void 0));
};
ScrollLockedImageText.defaultProps = defaultProps;
